import React, { Component } from 'react'
import { connect } from 'react-redux'
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom'
import MediaQuery from 'react-responsive'
import { Web3Connect, startWatching, initialize } from '../ducks/web3connect'
import { setAddresses } from '../ducks/addresses'
import Header from '../components/Header'
import Swap from './Swap'
import Send from './Send'
import Pool from './Pool'

import './App.scss'

class App extends Component {
  state = { timedOut: false }

  componentWillMount() {
    const { initialize, startWatching } = this.props
    initialize().then(startWatching)
    this.timeout = setTimeout(() => this.setState({ timedOut: true }), 1000)
  }

  componentWillUpdate() {
    const { web3, setAddresses } = this.props

    if (
      this.hasSetNetworkId ||
      !web3 ||
      !web3.eth ||
      !web3.eth.net ||
      !web3.eth.net.getId
    ) {
      return
    }

    web3.eth.net.getId((err, networkId) => {
      if (!err && !this.hasSetNetworkId) {
        setAddresses(web3, networkId)
        this.hasSetNetworkId = true
      }
    })
  }

  componentWillUnmount() {
    clearTimeout(this.timeout)
  }

  render() {
    if (!this.props.initialized && !this.state.timedOut) {
      return <noscript />
    }

    return (
      <div id="app-container">
        <MediaQuery query="(min-width: 768px)">
          <Header unlock={!this.props.initialized && this.state.timedOut} />
        </MediaQuery>
        <Web3Connect />
        <BrowserRouter>
          <Switch>
            <div className="app__wrapper">
              <Route exact path="/swap" component={Swap} />
              <Route exact path="/send" component={Send} />
              <Route exact path="/add-liquidity" component={Pool} />
              <Route exact path="/remove-liquidity" component={Pool} />
              <Route
                exact
                path="/create-exchange/:tokenAddress?"
                component={Pool}
              />
              <Redirect exact from="/" to="/swap" />
            </div>
          </Switch>
        </BrowserRouter>
      </div>
    )
  }
}

export default connect(
  state => ({
    account: state.web3connect.account,
    initialized: state.web3connect.initialized,
    web3: state.web3connect.web3
  }),
  dispatch => ({
    setAddresses: (web3, networkId) => dispatch(setAddresses(web3, networkId)),
    initialize: () => dispatch(initialize()),
    startWatching: () => dispatch(startWatching())
  })
)(App)
